import React from 'react';
import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBaseProduct } from '../../../helpers/getBaseProduct';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Heading } from '../../Common/Heading';
import { Caption } from '../../Common/Caption';
import { Selector, SelectorItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  bottomRailColour: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (bottomRailColour, send) => () =>
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      bottomRailColour,
    },
  });

export const BottomRailColour = () => {
  const [state, send] = useService(productBuilderMachine);
  const baseProduct = getBaseProduct(state.context);
  const bottomRailColourOptions = baseProduct
    ? baseProduct.metafields.bottom_rail_colour || []
    : [];
  const {
    custom: { bottomRailColour },
  } = state.context;

  if (isCurrentState('bottomRailColour', state) && bottomRailColourOptions.length === 0) {
    throwError(state);
  }

  return (
    <SectionContent>
      <Heading>Bottom rail colour</Heading>
      <Caption>Bottom rail colour</Caption>
      <Selector>
        {bottomRailColourOptions.map(option => {
          return (
            <SelectorItem
              isSelected={option === bottomRailColour}
              onClick={onClick(option, send)}
              key={option}
            >
              {option}
            </SelectorItem>
          );
        })}
      </Selector>
    </SectionContent>
  );
};
